import RequestForm from './form.js';

$(document).ready(function($) {

  let formOnlineApplication = $('[data-form-online-application]');
  if (formOnlineApplication.length) {

    RequestForm.validateForm(formOnlineApplication);

    var selectedEvent = $('[data-selected-event-type]:checked').data('selected-event-type');
    eventTypeChange(selectedEvent);
    $('[data-selected-event-type]').on('change', function(){
      selectedEvent = $(this).data('selected-event-type');
      eventTypeChange(selectedEvent);
    });
    
    // Если не дано согласие на обработку персональных данных - блокируем кнопку отправки формы
    $('body').on('change', '[data-agree-checkbox-online-application]', function(){
      var $btnSubmit = $('[data-form-online-application-submit]');

      $(this).is(':checked') ? 
          $btnSubmit.prop('disabled',false) : 
          $btnSubmit.prop('disabled',true);
    });
  }

  function eventTypeChange(eventType) {
    $('[data-event-type]').hide();
    $('[data-event-type="'+eventType+'"]').show();
  }

  formOnlineApplication.on('submit', function(e) {
    e.preventDefault();
    let applicationType = $('[name=APPLICATION_TYPE]').val(),
        $form = $(this);

    if ($form.valid()) {
      $.ajax({
        url      : '/'+window.langId+'/ajax/application-'+applicationType+'.php',
        data     : $form.serialize(),
        dataType : 'json',
        success  : function(data) {
          if(data.success){
            let formOnlineApplication = $('[data-form-online-application]');
            formOnlineApplication.remove();

            let successTextContainer = $('[data-form-online-application-success]');
            successTextContainer.css('color', 'green');
            successTextContainer.html(data.message);

          } else if(!data.success && data.error == 'recaptcha') {
            let errorCaptchaTextContainer = $('[data-form-online-application-captcha-error]');
            errorCaptchaTextContainer.html(data.message);
          }
        }
      });
    }
  });

  // recaptcha
  window.recaptchaCallback = function() {
    $('[data-form-online-application-captcha-error]').html('');
  }

});


// WEBPACK FOOTER //
// ./components/online-application.js